import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@radix-ui/react-accordion';
import { lowerCase } from 'lodash';

import { getSharedProperty } from '../../../getters';
import { useHeaderNavigation } from '../../MegaMenu';
import { LanguageItem } from '../LanguageItem';
import { LanguageType, RegionType } from '../LanguageSelector';
import { MobileRegionItem } from './MobileRegionItem';

export interface LanguageSelectorMobile {
  regions: RegionType[];
  currentLanguage?: LanguageType;
  handleRegionSelect: (id: string) => void;
}

export const LanguageSelectorMobile = ({ regions, currentLanguage }: LanguageSelectorMobile) => {
  const { currentLocale } = useHeaderNavigation();

  const selectedRegion = regions.find((region) =>
    region.languages.results.some(
      (l) => lowerCase(l.targetLocale.value) === lowerCase(currentLocale)
    )
  );

  return (
    <Accordion
      className="card-shadow flex w-full bg-white py-4 lg:hidden"
      type="single"
      defaultValue={selectedRegion?.id}
      collapsible
    >
      <ul className="flex w-full flex-col gap-3">
        {regions.map((region) => (
          <AccordionItem value={region.id} key={region.id} asChild>
            <li key={`mobile-ls-${region.id}`}>
              <AccordionTrigger className="group w-full">
                <MobileRegionItem
                  region={getSharedProperty(region, 'title')?.value || ''}
                  id={`language-selector-accordion-header-${region.id}`}
                  ariaControls={`language-selector-accordion-panel-${region.id}`}
                />
              </AccordionTrigger>
              <AccordionContent className="collapsible-content">
                <ul
                  id={`language-selector-accordion-panel-${region.id}`}
                  aria-labelledby={`language-selector-accordion-header-${region.id}`}
                  className="container grid grid-cols-1 justify-center gap-2 bg-gray-50 py-5 xxs:grid-cols-2 md:grid-cols-3"
                >
                  {region.languages.results.map((language) => {
                    const isActive = currentLanguage?.id === language.id;
                    return (
                      <LanguageItem
                        isActive={isActive}
                        key={`mobile-language-ls-${language.id}`}
                        icon={language.icon.jsonValue}
                        externalHost={language.targetHost.value}
                        locale={language.targetLocale.value}
                        language={language.languageName.value}
                        country={language.countryName.value}
                        focused={false}
                      />
                    );
                  })}
                </ul>
              </AccordionContent>
            </li>
          </AccordionItem>
        ))}
      </ul>
    </Accordion>
  );
};
